<script>
  import SmoothScroll from 'smooth-scroll'

  export default {
    props: ['menu', 'languages'],

    created () {
      new SmoothScroll('a[data-scroll]')

      this.$mq.desktop && window.addEventListener('scroll', this.scrolling)
    },

    computed: {
      langs () {
        return this.languages.filter(lang => lang.active === 0)
      },

      nav () {
        return this.menu.filter(item => item.classes[0] !== 'social')
      },

      social () {
        return this.menu.filter(item => item.classes[0] === 'social')
      }
    },

    methods: {
      scrolling () {
        this.menuScroll = window.scrollY > this.$el.clientHeight
      },

      className (icon) {
        return 'fa-' + icon
      },

      flag(cc) {
        return {
          'en': '🇬🇧',
          'fr': '🇫🇷',
          'de': '🇩🇪'
        }[cc];
      }
    },

    data () {
      return {
        menuOpen: false,
        menuScroll: false
      }
    }
  }
</script>

<template>
  <div>
    <nav id="top" class="navbar" role="navigation" aria-label="main navigation" :class="{ 'scroll': menuScroll }">
      <div class="container">
        <div class="navbar-brand" :class="{ 'is-active': menuOpen }">
          <button class="button navbar-burger" :class="{ 'is-active': menuOpen }" @click="menuOpen = !menuOpen">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <transition name="height">
          <div v-show="$mq.desktop || menuOpen" class="navbar-menu is-active">
            <div class="navbar-start"></div>
            <div class="navbar-end">
              <a class="navbar-item" v-for="link in nav" :key="link.title" :href="link.url" :class="link.classes">
                {{ link.title }}
              </a>
              <a class="navbar-item icon is-large" v-for="link in social" :key="link.title" :href="link.url" :class="link.classes">
                <i class="fa fa-2x" :class="className(link.classes[1])"></i>
              </a>
              <a class="navbar-item flag" v-for="lang in langs" :key="lang.id" :href="lang.url">
                {{ flag(lang.code) }}
              </a>
            </div>
          </div>
        </transition>
      </div>
    </nav>
    <div class="section mobile-logo is-hidden-desktop">
      <div class="container">
        <img class="blue-logo" src="../assets/logo.svg" alt="Purpose Create" width="457" height="44">
        <img class="white-logo" src="../assets/logo-white.svg" alt="Purpose Create" width="457" height="44">
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../sass/variables";

  .height-enter-active, .height-leave-active {
    transition: max-height 0.2s;
    max-height: 230px;
  }
  .height-enter, .height-leave-to
  {
    max-height: 0px;
  }

  .navbar, .mobile-logo {
    background: $pippin;
    position: relative;
    z-index: 4;
  }

  .navbar-brand.is-active, .navbar-menu {
    background: $blue;
  }

  .navbar-menu {
    overflow-y: hidden;
  }

  .navbar-burger {
    margin-left: 0;
    background: none;
    border: 0;
    color: $blue;
  }
  .navbar-burger.is-active {
    color: white;
  }

  .navbar-item {
    font-family: 'Separat';
    color: white;
  }

  .logo, .logo.navbar-item:hover {
    background: url(../assets/logo.svg);
    width: 457px;
    height: 44px;
    text-indent: -9999px;
  }

  @include desktop {
    .navbar {
      padding-top: calc(43px - 0.5rem);
      padding-bottom: calc(51px - 0.5rem);
    }
    .navbar-menu {
      display: block;
      background: none;
    }
    .navbar-item {
      font-family: 'Separat';
      color: $blue;
    }
    .flag {
      order: -1;
    }

    .scroll {
      position: fixed;
      top: 0;
      background: white;
      z-index: 10;
      width: 100%;
      height: 76px;
      padding-top: calc(22px - 0.5em);
      padding-bottom: calc(22px - 0.5rem);

      animation-name: slideInDown;
      animation-duration: 0.2s;
    }

    .scroll .logo, .scroll .logo:hover {
      width: 332px;
      height: 32px;
      background-size: 332px 32px;
    }
  }

  .navbar-end {
    justify-content: space-evenly;
  }
  .navbar-item:hover {
    background: none;
  }
  .navbar-item img {
    max-height: none;
  }

  @keyframes slideInDown {
    from {
      transform: translate3d(0, -100%, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  .white-logo {
    display: none;
  }
  .white .white-logo {
    display: block;
  }
  .white .blue-logo {
    display: none;
  }

  .white .navbar:not(.scroll) {
    background: transparent;

    .navbar-burger {
      color: white;
    }

    .navbar-item {
      color: white;
    }

    .logo {
      background-image: url(../assets/logo-white.svg);
    }
  }

  .white .mobile-logo {
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// partials/CreateNav.vue